/*
 * Copyright Deskshare, Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * Profile API Service
 */

import { createApi } from "@reduxjs/toolkit/query/react";
import type { StripeCustomer } from "@/types";
import {
  baseQueryWithReauth,
  CACHE_TIMES,
  TAG_TYPES,
} from "@/redux/api-config";

export const profileApi = createApi({
  reducerPath: "profileApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: [TAG_TYPES.PROFILE],
  // Keep profile data for 5 minutes
  keepUnusedDataFor: CACHE_TIMES.MEDIUM,
  endpoints: (builder) => ({
    getProfile: builder.query<StripeCustomer, void>({
      query: () => "users/profile",
      providesTags: [TAG_TYPES.PROFILE],
    }),
    updateProfile: builder.mutation<StripeCustomer, Partial<StripeCustomer>>({
      query: (body) => ({
        url: "users/profile",
        method: "PUT",
        body,
      }),
      // Invalidate profile cache after update
      invalidatesTags: [TAG_TYPES.PROFILE],
    }),
  }),
});

export const {
  useGetProfileQuery,
  useUpdateProfileMutation,
} = profileApi;
